import type { Nutrient } from '@shared/gql/document-nodes'
import type { FC } from 'react'

import { NutrientInfoTable } from './NutrientInfoTable'

const TABLE_HEADERS = [
  {
    index: 1,
    headerI18nKey: 'Nutrition declaration',
  },
  {
    index: 2,
    headerI18nKey: '100g/100ml',
  },
  {
    index: 3,
    headerI18nKey: 'Reference intake',
  },
]

/* The indentation of table items relies on text content at the moment, because
   the alternative is to rely on the order of items passed from the backend. */
const INDENTED_PARENT_NAMES = ['Rasvaa', 'Hiilihydraattia']
const INDENTED_NAMES = ['Rasvaa, josta tyydyttyneitä rasvoja', 'Hiilihydraattia, joista sokereita']

const isParentOfIndented = (nutrient: Pick<Nutrient, 'name'>) =>
  !!INDENTED_PARENT_NAMES.find((name) => name === nutrient.name)

const shouldBeIndented = (nutrient: Pick<Nutrient, 'name'>) =>
  !!INDENTED_NAMES.find((name) => name === nutrient.name)

const renderNutrientPerUnitInfo = (
  nutrient: Pick<Nutrient, 'name' | 'ri' | 'value'>,
  index: number,
) => (
  <div
    className={`tableRow
      ${shouldBeIndented(nutrient) ? 'indented' : ''}
      ${isParentOfIndented(nutrient) ? 'indented-parent' : ''}`}
    key={index}
  >
    <div className="cell">{nutrient.name}</div>
    <div className="cell">{nutrient.value}</div>
    <div className="cell greyed">{nutrient.ri}</div>
  </div>
)

interface NutrientsPerUnitInfoTableProps {
  nutrients: Pick<Nutrient, 'name' | 'ri' | 'value'>[]
}

export const NutrientsPerUnitInfoTable: FC<NutrientsPerUnitInfoTableProps> = ({ nutrients }) => {
  return (
    <NutrientInfoTable headers={TABLE_HEADERS}>
      {nutrients.map((nutrient, index) => renderNutrientPerUnitInfo(nutrient, index))}
    </NutrientInfoTable>
  )
}
